define('glu/routeManager',['require','./urlManager','./util'],function(require) {
    'use strict';

    var UrlManager = require('./urlManager'),
        util = require('./util');

    var RouteManager = UrlManager.extend({
        root: '/',

        registerRoutes: function(urls) {
            util.extend(this.urls, urls);
            this.initializeUrls();
            return this;
        },

        setRoot: function(root) {
            this.root = root;
            return this;
        }
    });

    return new RouteManager();
});

